import React, { useState } from 'react';
import SimpleSlider from './image-slider';
import {
  TickOneIcon,
  OneFacebookIcon,
  OneInstagramIcon,
  OneTikTokIcon,
} from '../../atoms/icons';
import { redirectToProductDetails } from '../../../utils';
import NoImage from '../../../assets/images/no-image.png';
import defaultAvatar from '../../../assets/images/default-avatar.jpg';
import VideoSlider from './video-slider';

export const TemplateSeven = ({
  expertiseData,
  preferredBrands,
  preferredProducts,
  redirectToBuyerPortal,
  redirectToShopPortal,
  cardDetails,
  schedulerEnabled,
}) => {
  const { seller, storefront } = cardDetails?.current?.config;
  const LogoUrl =
    storefront?.general?.longLogoImage?.url ||
    storefront?.general?.logoImage?.url ||
    null;

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      <section className="seven-warpper">
        <div className="mainWrapper">
          <header className="flex justify-between items-center gap-6 px-4">
            {LogoUrl ? (
              <div className="logo-box max-w-56">
                <img src={LogoUrl} alt="logo" />
              </div>
            ) : (
              <h2 className="logo-text text-sevenPrimary capitalize">
                {storefront?.general?.name}
              </h2>
            )}
          </header>

          <div className="seaven-profile-head">
            <div className="left-part">
              <div>
                <div className="image-wrapper">
                  <img
                    src={
                      seller?.profile?.avatar?.mediumUrl ||
                      seller?.profile?.avatar?.url ||
                      defaultAvatar
                    }
                    alt="picture"
                    className="profilebg"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = defaultAvatar;
                    }}
                  />
                </div>
                <div className="flex gap-4 lg:justify-center justify-start items-center lg:ml-0 ml-5 mt-4 md:mt-8">
                  {seller?.profile?.facebookUrl && (
                    <a
                      href={seller?.profile?.facebookUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneFacebookIcon className="text-sevenPrimary" />
                    </a>
                  )}
                  {seller?.profile?.instagramUrl && (
                    <a
                      href={seller?.profile?.instagramUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneInstagramIcon className="text-sevenPrimary" />
                    </a>
                  )}
                  {seller?.profile?.tiktokUrl && (
                    <a
                      href={seller?.profile?.tiktokUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cursor-pointer"
                    >
                      <OneTikTokIcon className="text-sevenPrimary" />
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div className="right-part">
              <h2 className="text-black-main font-bold md:text-5xl text-4xl font-tempOne capitalize">
                {seller?.profile?.title}
              </h2>
              <div className="md:boder-left md:border-l-4 border-sevenPrimary mt-5">
                <div className="long-text">
                  <p
                    className={
                      isExpanded
                        ? 'full-text'
                        : seller?.profile?.about?.length > 600
                        ? 'clamped-text'
                        : ''
                    }
                  >
                    <p
                      className="font-normal italic md:text-xl text-base  md:pl-4"
                      dangerouslySetInnerHTML={{
                        __html: seller?.profile?.about,
                      }}
                    />
                  </p>
                  {seller?.profile?.about?.length > 600 && (
                    <button
                      className="read-text pl-4 text-sevenPrimary"
                      onClick={toggleReadMore}
                    >
                      {isExpanded ? 'Read Less' : 'Read More'}
                    </button>
                  )}
                </div>
                <div className="md:ml-4 mt-7">
                  <button
                    className="bg-sevenPrimary text-white-main font-bold text-lg md:w-auto w-full justify-center rounded-SevenCustom px-10 py-4 flex items-center gap-4"
                    onClick={() =>
                      redirectToShopPortal(storefront?.general?.shopUrl)
                    }
                  >
                    <span>Shop the store</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="13"
                      viewBox="0 0 28 13"
                      fill="none"
                    >
                      <path
                        d="M27 6.5H1"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M27 6.5L23 11.5"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M27 6.5L23 1.5"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <section
            className={`flex md:gap-12 flex-col mobile-padding ${
              expertiseData?.length === 0 && 'items-start'
            }`}
          >
            <div className="box-wrp">
              {expertiseData?.length ? (
                <div
                  className={
                    expertiseData?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <h2 className="text-sevenPrimary font-semibold text-2xl font-tempOne mt-10 mb-5">
                    Expertise
                  </h2>
                  <ul className="columns-2">
                    {expertiseData?.map((item, index) => (
                      <li key={index} className="flex items-center mb-4">
                        <TickOneIcon className="text-sevenPrimary" />
                        <span className="ml-2.5 font-normal text-base">
                          {item?.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div
                  className={
                    seller?.profile?.expertise
                      ? 'visibility-auto'
                      : 'visibility-hidden'
                  }
                >
                  <h2 className="text-sevenPrimary font-semibold text-2xl font-tempOne mt-10 mb-5">
                    Expertise
                  </h2>
                  <p
                    className="font-normal md:text-xl text-base  md:pl-4"
                    dangerouslySetInnerHTML={{
                      __html: seller?.profile?.expertise,
                    }}
                  />
                </div>
              )}
              {schedulerEnabled && (
                <div className="flex md:justify-start justify-center mt-6">
                  <button
                    className="bg-sevenPrimary text-white-main font-bold text-lg md:w-auto w-full justify-center rounded-SevenCustom px-10 py-4 flex items-center gap-4"
                    onClick={() => redirectToBuyerPortal()}
                  >
                    <span>Book an appointment</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="13"
                      viewBox="0 0 28 13"
                      fill="none"
                    >
                      <path
                        d="M27 6.5H1"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M27 6.5L23 11.5"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M27 6.5L23 1.5"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </div>
            <div>
              {preferredProducts?.length ? (
                <div
                  className={
                    preferredProducts?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <h2 className="text-black-main font-semibold text-2xl font-tempOne mt-7 mb-5 md:text-left text-center">
                    My Favorite Products
                  </h2>
                  <div className="flex md:gap-4 gap-2 flex-wrap justify-center">
                    {preferredProducts?.slice(0, 4).map((product, index) => (
                      <div
                        key={index}
                        className="image-wrp cursor-pointer"
                        onClick={() =>
                          redirectToProductDetails(
                            storefront?.general?.shopUrl +
                              '/products/' +
                              product?.slug
                          )
                        }
                      >
                        <img
                          src={
                            product?.primaryImage?.mediumUrl ||
                            product?.primaryImage?.thumbUrl ||
                            NoImage
                          }
                          alt={`Product ${index + 1}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : preferredBrands?.length ? (
                <div
                  className={
                    preferredBrands?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <h2 className="text-black-main font-semibold text-2xl font-tempOne mt-7 mb-5 md:text-left text-center">
                    My Favorite Brands
                  </h2>
                  <div className="flex md:gap-4 gap-2 flex-wrap justify-center">
                    {preferredBrands?.slice(0, 4).map((product, index) => (
                      <div
                        key={index}
                        className="image-wrp cursor-pointer"
                        onClick={() =>
                          redirectToProductDetails(
                            storefront?.general?.shopUrl +
                              '/brands/' +
                              product?.slug
                          )
                        }
                      >
                        <img
                          src={
                            product?.coverImage?.mediumUrl ||
                            product?.coverImage?.thumbUrl ||
                            NoImage
                          }
                          alt={`Product ${index + 1}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </section>
          {seller?.profile?.galleryImages?.length ? (
            <div className=" mt-10">
              <h2 className="text-sevenPrimary font-semibold text-2xl md:mt-10 mt-4 font-tempOne  mb-5 pl-4 md:pl-0 text-left">
                Salon Gallery
              </h2>
              <section className="banner">
                <SimpleSlider images={seller?.profile?.galleryImages} />
              </section>
            </div>
          ) : (
            <></>
          )}
          {seller?.profile?.galleryVideoLinks?.length ? (
            <>
              <h2 className="text-sevenPrimary font-semibold text-2xl md:mt-10 mt-4 font-tempOne  mb-5 pl-4 md:pl-0 text-left">
                Salon Videos
              </h2>
              <section className="banner">
                <VideoSlider videos={seller?.profile?.galleryVideoLinks} />
              </section>
            </>
          ) : (
            <></>
          )}
        </div>
      </section>
    </>
  );
};
